// Copyright (c) Ping. All rights reserved.

/**
 * Threads module strings. Keys follow the `ping_threads_*` prefix from
 * `_NAMING_CONTRACT-WAVE2.md`. Web/desktop resolves these at render time
 * via the app's i18n layer; English copy below is the development
 * fallback baked into the package.
 */
export const threadsStrings = {
  ping_threads_view_thread: 'View Thread',
  ping_threads_no_replies: 'No replies',
  ping_threads_one_reply: '1 reply',
  ping_threads_many_replies: (count: number): string => `${count} replies`,
  ping_threads_panel_title: 'Thread',
  ping_threads_panel_close: 'Close thread',
  ping_threads_panel_options: 'Thread options',
  ping_threads_panel_subtitle: (count: number): string => {
    if (count <= 0) {
      return 'No replies yet';
    }
    if (count === 1) {
      return '1 reply';
    }
    return `${count} replies`;
  },
  ping_threads_participants_label: 'Participants',
  ping_threads_participants_overflow: (count: number): string => `+${count}`,
  ping_threads_empty_title: 'Start the conversation',
  ping_threads_empty_body: 'Replies you send here only show up in this thread.',
  ping_threads_composer_placeholder: 'Reply to thread',
  ping_threads_composer_send: 'Send',
  ping_threads_composer_disabled_hint: 'Thread closed by author',
  ping_threads_parent_deleted: 'Original message deleted',
  ping_threads_error_title: "Couldn't load this thread",
  ping_threads_error_retry: 'Try again',
  ping_threads_send_failed_hint: "Couldn't send reply — tap to retry",
  ping_threads_loading_label: 'Loading thread',
} as const;

export type ThreadsStrings = typeof threadsStrings;

/**
 * Pure helper for `ThreadInChat` and `ThreadHeader`. Tested in
 * `threadSummary.test.ts`.
 */
export function formatReplyCount(count: number): string {
  if (count <= 0) {
    return threadsStrings.ping_threads_no_replies;
  }
  if (count === 1) {
    return threadsStrings.ping_threads_one_reply;
  }
  return threadsStrings.ping_threads_many_replies(count);
}
